// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"638":"0bfa6604","685":"ac77d395","871":"9f239b28"}[chunkId] + ".css";
};